import { ReactComponent as LogoInventa } from 'src/img/inventa-logo.svg';

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-0 border-0">
      <a className="navbar-brand logo" href="/">
        <LogoInventa
          alt="InventaLogo"
          className="pb-2 logo-svg logo-alignment-fix"
        />
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item active">
            <a
              className="nav-link text-secondary"
              href="https://inventa.shop/pages/fornecedor"
            >
              <span>Fornecedor</span>
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link text-secondary" href="https://inventa.shop">
              <span>Lojista</span>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link text-secondary"
              href="https://inventa.shop/pages/contato"
            >
              <span>Contato</span>
            </a>
          </li>
        </ul>
        <div id="menu-right" className="my-2 my-lg-0">
          <a
            href="https://inventa.shop"
            className="btn btn-outline-secondary mr-4 px-4"
          >
            <span>Acesso lojista</span>
          </a>
          <a
            href="/"
            className="btn btn-warning background-yellow-accent color-inventa-main-100"
          >
            <span>Painel Fornecedor</span>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Header;
